import "./style.scss";

import { InputLabel } from "@mui/material";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import type { SubmitHandler } from "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
// Imports from React
import { useDispatch } from "react-redux";
import { fetchCreateEntry } from "store/accountingStore";
// Imports from store
import type { AppDispatch } from "store/store";
import type { AccountingEntry } from "store/types";

export const textFieldStyles = {
    "&.MuiTextField-root": {
        margin: "auto",
        width: "350px",
    },
    ".MuiFormHelperText-root": {
        color: "rgb(211, 47, 47)",
    },
};

interface IDuplicateEntry {
    entry: AccountingEntry;
    close: (success: boolean) => void;
}

type TFormEntry = {
    name: string;
};

const DuplicateEntry = ({ entry, close }: IDuplicateEntry) => {
    const [t] = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    const onSubmit: SubmitHandler<TFormEntry> = (form) => {
        dispatch(
            fetchCreateEntry({
                ...entry,
                name: form.name,
                filters: {
                    ...entry.filters,
                    typology: form.name,
                },
            }),
        ).then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
                const element = document.getElementById(`typology-${(resp.payload as any).data.id}`);
                element?.scrollIntoView({ behavior: "smooth" });
            }
        });
        close(true);
    };

    const methods = useForm<TFormEntry>({
        defaultValues: {
            name: "",
        },
    });
    const {
        control,
        handleSubmit,
        // formState: { errors },
        // reset,
        // setError,
        // watch,
        // setValue,
    } = methods;

    return (
        <div className="typology-modal-wrapper">
            <h3>{t("Accounting.ModalDuplicateEntry.ModalInstruction")}</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <div className="input-group-form" style={{ marginBottom: "1.5rem" }}>
                            <InputLabel
                                sx={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    fontFamily: "Poppins",
                                    marginLeft: "0.3rem",
                                    color: "rgb(131 130 130)",
                                }}
                                htmlFor="name"
                            >
                                {t("Accounting.EntryTypeName")}
                            </InputLabel>
                            <StyledTextField id="name" sx={textFieldStyles} {...field} />
                        </div>
                    )}
                />
                <div className="duplicate-modal-btn">
                    <button className="btn-cancel" onClick={() => close(true)}>
                        {t("Accounting.Cancel")}
                    </button>
                    <button className="btn-validate" type="submit">
                        {t("Accounting.Validate")}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default DuplicateEntry;
